import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from "src/app/services/customer.service";
import { VendorService } from "src/app/services/vendor.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { EditViewDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/delete-view.component";
import { Utilities } from "src/app/models/utilities";
import { RateBandsService } from "src/app/services/ratebands.service";
import { FileHandlerService } from "src/app/services/file-handler.service";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { UploadActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/mapping.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ChargedetailsComponent } from "./details/chargedetails.component";
import { ChargeperiodComponent } from "./periods/chargeperiod.component";
import { ChargeWeightSlabsComponent } from "./slab-details/charge-weight-slabs.component";
import { AppCoreService } from "src/app/services/app-core.service";
import { ExcelService } from "src/app/services/excel.service";
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})

export class UploadComponent implements OnInit, AfterViewInit {
  chargeUploadForm!: FormGroup;
  isFormSubmitted: boolean;
  showPeriodModal: boolean;
  showChargeModal: boolean;
  showSlabsModal: boolean;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  periodData: any;
  chargeDetailData: any;
  showDownloadBtn = false;
  showBands = false;
  showCustomer = false;
  showVendor = false;
  selectedFile: File | null = null;
  isCategoryMand = false;
  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };
  public context: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  periodId: number; //chargePeriod table serial id 
  mappingId: number;

  showProgressBar = false;
  progress: number = 0;

  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
  };

  gridOptionsPeriod: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 5
  }
  gridOptions: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 10
  }
  rowDataInfo: any[] = [];
  rowDataPeriod = [];
  columnDefsPeriod = [
    { headerName: 'Charge Type', field: 'chargetype' },
    { headerName: 'Category', field: 'chargecategory' },
    { headerName: 'Surcharge Type', field: 'surchargetype' },
    { headerName: 'From Date', field: 'fromdate' },
    { headerName: 'To Date', field: 'todate' },
    { headerName: 'Band', field: 'rateband' },
    { headerName: 'Customer', field: 'customer' },
    { headerName: 'Vendor', field: 'vendor' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditViewDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 100,
    },
  ];
  columnDefs = [
    { headerName: 'Charge', field: 'chargename', minWidth: 180 },
    { headerName: 'Product', field: 'productcode', minWidth: 90 },
    { headerName: 'Vendor', field: 'vendorcode', minWidth: 90 },
    { headerName: 'Service', field: 'servicename', minWidth: 180 },
    { headerName: 'Origin Country', field: 'origincountrycode', minWidth: 180 },
    { headerName: 'Origin State', field: 'originstatecode', minWidth: 180 },
    { headerName: 'Origin City', field: 'origincitycode', minWidth: 180 },
    { headerName: 'Destination Country', field: 'destinationcountrycode', minWidth: 180 },
    { headerName: 'Destination State', field: 'destinationstatecode', minWidth: 180 },
    { headerName: 'Destination City', field: 'destinationcitycode', minWidth: 180 },
    { headerName: 'Calculation By', field: 'calculationby', minWidth: 180 },
    { headerName: 'Chargeable Amount', field: 'chargeableamount', minWidth: 140, pinned: 'right' },
    {
      headerName: 'Actions',
      field: 'id',
      //cellRenderer: EditDeleteActionsRenderer,
      cellRenderer: UploadActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      filter: false,
      sortable: false,
      minWidth: 120,
      pinned: 'right'
    },
  ];
  currentDate: any;
  showCategory = false;
  useEnterKey: any;
  chargeTypeList = []
  chargeCategoriesList = []
  constructor(
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private utilities: Utilities,
    private customerService: CustomerService,
    private vendorService: VendorService,
    private chargeService: ChargesService,
    private chargeBandsService: RateBandsService,
    private fileHandlerService: FileHandlerService,
    private appCoreService: AppCoreService,
    private excelService: ExcelService,
    public modalService: NgbModal,
    private titleService: Title
  ) {
    titleService.setTitle('Charges');
    this.context = { componentParent: this, actionConfig: { update: true } };
  }

  ngOnInit(): void {
    // set full width for this page 
    const bodyTag = document.body;
    bodyTag.classList.add('sidebar-enable')
    bodyTag.classList.add('vertical-collpsed');

    this.currentDate = this.utilities.FormatDateWithTime();
    this.chargeUploadForm = this.formBuilder.group({

    });
    this.getAllPeriods();
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    this.getAllChargeTypes();
    this.checkPermission();
  };

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.chargeUploadForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData(); 
    const permission = userData.config.filter(x => x.categoryname === 'Upload');
    if (permission.length) {
        this.permConfig.isViewAllowed = permission[0].view;
        this.permConfig.isAddAllowed = permission[0].add;
        this.permConfig.isEditAllowed = permission[0].edit;
        this.permConfig.isDeleteAllowed = permission[0].delete;
    }
}

  getAllChargeTypes() {
    this.chargeService.GetAllTypes().subscribe(res => {
      try {
        if (res && res.success) {
          this.chargeTypeList = res.data.types;
          this.chargeCategoriesList = res.data.categories;
        }
      } catch (error) {
        console.error(error);
      }
    })
  }

  openPeriodModel(data: any) {
    this.ngxLoaderService.start();
    const modalRef = this.modalService.open(ChargeperiodComponent, this.ngbModalOptions);
    modalRef.componentInstance.chargeTypeList = this.chargeTypeList;
    modalRef.componentInstance.chargeCategoriesList = this.chargeCategoriesList;
    modalRef.componentInstance.periodData = data[0];
    modalRef.result.then(
      (data) => {
        if (data) {
          this.getAllPeriods();
        }
      },
      (reason) => {
        if (reason == 'Cross click') {
        }
      }
    );
    this.ngxLoaderService.stop();
  }

  openChargeDetailModel(data: any) {
    this.ngxLoaderService.start();
    const modalRef = this.modalService.open(ChargedetailsComponent, this.ngbModalOptions);
    modalRef.componentInstance.chargeDetailData = data;
    modalRef.result.then(
      (data) => {
        if (data) {
          this.bindChargeInfo(this.periodId);
        }
      },
      (reason) => {
        if (reason == 'Cross click') {
        }
      }
    );
    this.ngxLoaderService.stop();
  }

  openWeightSlabModel(mappingId: any) {
    this.ngxLoaderService.start();
    const modalRef = this.modalService.open(ChargeWeightSlabsComponent, this.ngbModalOptions);
    modalRef.componentInstance.mappingId = mappingId;
    modalRef.result.then(
      (data) => {
        if (data) {
          // this.bindChargeInfo(this.periodId);
        }
      },
      (reason) => {
        if (reason == 'Cross click') {
        }
      }
    );
  }

  getAllPeriods(refresh = false) {
    this.ngxLoaderService.start();
    this.chargeService.GetAllPeriods({ refresh: refresh }).subscribe(res => {
      try {
        if (res && res.data) {
          this.ngxLoaderService.stop();
          this.rowDataPeriod = res.data;
          // console.log(res.data);
        } else {
          this.ngxLoaderService.stop();
        }
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    })
  }


  bindChargeInfo(chargePeriodId: any) {
    this.chargeService.GetChargeInfoByPeriod(chargePeriodId).subscribe(res => {
      try {
        this.ngxLoaderService.start();
        if (res && res.data) {
          this.ngxLoaderService.stop();
          this.rowDataInfo = [];
          this.rowDataInfo = res.data;
        }
      } catch (error) {
        this.ngxLoaderService.stop();
        console.error(error);
      }
    })
  }

  onGridReadyPeriod(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    try {
      if (cell) {
        //find the cell in rowDataInfo List
        this.chargeDetailData = this.rowDataInfo.find(item => item.id === cell.id);
        // console.log(this.chargeDetailData);
        this.openChargeDetailModel(this.chargeDetailData);
      }
    } catch (e) {
      console.error(e);
    }

  }

  //period**
  editPeriodAction(cell: any) {
    try {
      if (cell) {
        //find the cell in rowDataInfo List
        this.chargeService.getChargePeriodById(cell.id).subscribe(res => {
          if (res?.success) {
            this.openPeriodModel(res.data);
          }
        })
      }
    } catch (e) {
      console.error(e);
    }
  }

  viewAction(cell: any) {
    if (cell) {
      // console.log(cell);

      this.periodId = cell.id;
      this.bindChargeInfo(this.periodId);
    }
  }

  addAction(cell: any) {
    try {
      if (cell && cell.id) {
        this.mappingId = cell.id;
        this.openWeightSlabModel(this.mappingId);
      }
    }
    catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }

  async deletePeriodAction(cell: any) {
    if (cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed) {
        this.ngxLoaderService.start();
        this.chargeService.DeleteChargePeriodById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.getAllPeriods(true);
              this.periodId === cell.id ? this.rowDataInfo = [] : null;
            } else if (res && res.success) {
              this.ngxLoaderService.stop();
            }
          } catch (error) {
            console.error(error);
            this.ngxLoaderService.stop();
          }
        });
      }
    }
  }

  async deleteAction(cell: any) {
    if (cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed) {
        this.ngxLoaderService.start();
        this.chargeService.Upload_Delete(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.bindChargeInfo(this.periodId);
            } else if (res && res.succes) {
              this.ngxLoaderService.stop();
            }
          } catch (error) {
            console.error(error);
            this.ngxLoaderService.stop();
          }
        });

      }
    }
  }

  onUpdatePeriod(e: any) {
    this.showPeriodModal = false;
    this.getAllPeriods(true);
  }

  onUpdateChargeDetails(e: any) {
    this.showChargeModal = false;
    this.bindChargeInfo(this.periodId);
  }

  async invalidPeriodDialog(msg: string) {
    const result = await Swal.fire({
      titleText: 'Error',
      html: msg,
      icon: 'error',
      // confirmButtonText: 'Yes',
      // showDenyButton: true,
      // denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });

    if (result.isConfirmed) {
      return false;
    }
  }

  async openConfirmationDialog() {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: "This action is irreversible. Are you sure you want to delete?",
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  async successDialog(msg?: any) {
    const success = await Swal.fire({
      titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (success.isConfirmed) {
      this.getAllPeriods(true);
      this.isFormSubmitted = false;
      this.chargeUploadForm.reset();
      this.chargeUploadForm.controls.txtFromDate.setValue(this.currentDate.dateString);
      this.chargeUploadForm.controls.txtToDate.setValue(this.currentDate.dateString);
    }
  }

  onClosePeriod(e: any) {
    this.showPeriodModal = false;
  }

  onCloseChargeDetails(e: any) {
    this.showChargeModal = false;
    this.bindChargeInfo(this.periodId);
    //console.log('onCloseChargeDetails', this.showChargeModal);
  }

  onCloseChargesSlabDetail(e: any) {
    this.showSlabsModal = false;
    //console.log('onCloseChargeDetails', this.showChargeModal);
  }
}